import ArticleFooter from "@components/Article/ArticleFooter";
import ArticlePreview from "@components/Article/ArticlePreview";
import ArticleWithPreviewArticle from "@components/ArticlePage/ArticleWithPreviewArticle";
import ArticleBreadcrumb from "@components/Breadcrumbs/ArticleBreadcrumb";
import Welcome from "@components/Welcome";
import type { ArticlePageData } from "@core/SitePresenter/types/ArticlePage";
import ResourceService from "@core-ui/ContextServices/ResourceService/ResourceService";
import useShowMainLangContentPreview from "@core-ui/hooks/useShowMainLangContentPreview";
import { useItemLinks } from "@core-ui/stores/ItemLinksStore/ItemLinksStore.provider";
import ArticleErrorHandler from "@ext/errorHandlers/client/components/ArticleErrorHandler";
import { useEffect } from "react";
import Article from "../Article/Article";

const ArticlePage = ({ data }: { data: ArticlePageData }) => {
	const { clear } = ResourceService.value;
	const isShowMainLangContentPreview = useShowMainLangContentPreview();
	const itemLinks = useItemLinks();

	// biome-ignore lint/correctness/useExhaustiveDependencies: expected
	useEffect(() => clear(), [data.articleProps.logicPath]);

	if (data.articleProps.welcome) return <Welcome data={data} />;
	return (
		<div className="flex flex-col h-fit min-h-dvh sm:h-full sm:min-h-0">
			<ArticleErrorHandler key={data.articleProps.logicPath}>
				<ArticleBreadcrumb
					hasPreview={isShowMainLangContentPreview}
					itemLinks={itemLinks}
					showActions={data.mode !== "markdown"}
				/>
				<ArticleWithPreviewArticle
					mainArticle={<Article data={data} />}
					previewArticle={
						isShowMainLangContentPreview && <ArticlePreview logicPath={data.articleProps.logicPath} />
					}
				/>
				<ArticleFooter />
			</ArticleErrorHandler>
		</div>
	);
};

export default ArticlePage;
